import Vue from "vue";

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo);

import Tabs from "vue-tabs-component";
Vue.use(Tabs);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import VModal from "vue-js-modal";
Vue.use(VModal, { dynamic: true });

import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);

import Transitions from "vue2-transitions";
Vue.use(Transitions);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// Fontawesome
require("./fontawesome");

// Validation
import { extend, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
});
Vue.component("ValidationProvider", ValidationProvider);

// import moment from "moment-timezone";
// moment.tz.setDefault("Europe/Paris");

// window.axiosForTus = require('axios');
// window.axiosForTus.defaults.headers.common = {};

// require('vue2-animate/dist/vue2-animate.min.css');

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

// let token = document.head.querySelector('meta[name="csrf-token"]');

// if (token) {
//   window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
// } else {
//   console.error(
//     "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
//   );
// }
